// libraries
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { Avatar, Tooltip, Typography } from 'antd';
import { TeamOutlined } from '@ant-design/icons';
import { blue } from '@ant-design/colors';

// utils
import { txt } from '../../../../locales/i18n';
import { formatDate } from '../../../../utils/date';
import { useDeviceSize } from '../../../../hooks/device-size';

export type UnionPageFormProps = {
	union: Record<string, any>;
};

export function UnionPageHeader({ union }: UnionPageFormProps): JSX.Element {
	const isMobileDevice: boolean = useDeviceSize();

	return (
		<StyledGroupHeader>
			{isMobileDevice === false && <Avatar size={64} icon={<TeamOutlined />} />}

			<div className="details-container">
				<h3>
					<span>{union.title}</span>
					<Typography.Text type="secondary">{union.municipalityName}</Typography.Text>
				</h3>

				<Tooltip title={`${txt('global.created by')} ${union.username}`}>
					<Link to={`/users/${union.userId}`} className="user-details-container">
						<span>{union.username}</span>
						<Typography.Text type="secondary">{union.userMunicipality}</Typography.Text>
						<Typography.Text type="secondary">{formatDate(union.created)}</Typography.Text>
					</Link>
				</Tooltip>
			</div>
		</StyledGroupHeader>
	);
}

const StyledGroupHeader = styled.section`
	display: flex;
	align-items: center;
	gap: 1em;

	.details-container {
		display: flex;
		flex-direction: column;

		h3 {
			margin: 0;
			display: flex;
			gap: 1ch;
		}

		.user-details-container {
			color: ${blue.primary};
			display: flex;
			gap: 1ch;
		}
	}
`;
